import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ImageUploading from "react-images-uploading";
import EditIcon from "@material-ui/icons/Edit";
import {
  DatePickerValidator,
  PhoneInputValidator,
  RadioGroupValidator,
} from "../../../../utilities/validators";

import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import {
  addPatientRequest,
  getSignedUrlRequest,
  searchPatientsRequest,
  uploadToS3Request,
} from "../../PatientApiActions";
import { useStyles } from "./styles";
import PersonAddRoundedIcon from "@material-ui/icons/PersonAddRounded";
import UtilHelper from "../../../../utilities/validators/UtilHelper";
import { IMAGE_FILE_TYPES } from "../../../../utilities/constants";
import { Autocomplete } from "@material-ui/lab";

/**
 * function to render athlete form
 * @param selectedDept: selected department
 * @returns {JSX.Element}
 * @constructor
 */
const AddPatient = ({
  selectedDept,
  openCreateAthleteModal,
  setOpenCreateAthleteModal,
  addPatient,
  setSelectedAthlete,
  getSignedUrl,
  uploadToS3,
  selectedDepartment,
  searchPatients,
  patients,
}) => {
  const classes = useStyles();
  const [profileImage, setProfileImage] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [gender, setGender] = useState("");
  const [patientId, setPatientId] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchPatientsQuery, setSearchPatientsQuery] = useState(null);
  const [allPatients, setAllPatients] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (searchPatientsQuery?.length > 2) {
      searchPatients(searchPatientsQuery).then((result) => {
        setAllPatients(result || []);
        setIsInitialLoad(false);
      });
    } else {
      setAllPatients([]);
    }
  }, [searchPatientsQuery]);

  /**
   * function to handle add athlete
   * @param e
   */
  const onSubmit = (e) => {
    e.preventDefault();

    const finalPatientId = patientId || phone.replace(/^\+91/, "");

    const data = {
      firstName: firstName,
      lastName: lastName,
      dob: dateOfBirth ? moment(dateOfBirth).format("MM-DD-YYYY") : "",
      gender: gender,
      TeamId: selectedDepartment ? selectedDepartment.id : selectedDept.team_id,
      mobile: phone,
      patientId: finalPatientId,
    };

    if (profileImage) {
      const imageData = {
        fileName: profileImage[0].file.name,
        fileType: `.${profileImage[0].file.name.split(".").pop()}`,
      };

      getSignedUrl(imageData).then((res) => {
        uploadToS3(res.urls, profileImage[0].file).then(() => {
          data["imageUrl"] = res.path;
          addPatient(data).then((res) => {
            handleClose();
            setSelectedAthlete(res);
          });
        });
      });
    } else {
      addPatient(data).then((res) => {
        handleClose();
        setSelectedAthlete(res);
      });
    }
  };

  useEffect(() => {
    ValidatorForm.addValidationRule("isBlank", (value) =>
      UtilHelper.validateBlankSpace(value)
    );
    ValidatorForm.addValidationRule("isValidMobile", (value) =>
      UtilHelper.validateMobile(value)
    );
    ValidatorForm.addValidationRule("isMaxLength", (value) =>
      UtilHelper.validateMaxLength(value)
    );

    return () => {
      ValidatorForm.removeValidationRule("isBlank");
      ValidatorForm.removeValidationRule("isValidMobile");
      ValidatorForm.removeValidationRule("isMaxLength");
      ValidatorForm.removeValidationRule("isSSN");
    };
  }, []);
  /**
   * function to handle dialog close
   */
  const handleClose = () => {
    setOpenCreateAthleteModal(false);
    setSearchPatientsQuery(null);
    setProfileImage(null);
    setFirstName("");
    setLastName("");
    setDateOfBirth(null);
    setGender("");
    setPhone("");
    setPatientId("");
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={openCreateAthleteModal}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.dialogHeader}>
        <Box className={classes.dialogHeaderIcon}>
          <PersonAddRoundedIcon style={{ fontSize: 22 }} />
        </Box>
        <Typography className={classes.dialogTitleText}>Add Patient</Typography>
      </Box>

      <ValidatorForm onSubmit={onSubmit}>
        <DialogContent classes={{ root: classes.dialogContentContainer }}>
          <Box>
            <Box mb={1}>
              <Typography variant="body1">
                Search Existing patient Using Phone
              </Typography>
            </Box>

            <Autocomplete
              fullWidth
              size="small"
              value={selectedPatient}
              className={classes.searchPatient}
              onChange={(event, newValue) => {
                setSelectedPatient(newValue);
                if (newValue) {
                  setFirstName(newValue.attributes.name || "");
                  setPhone(
                    newValue.attributes.phone_number
                      ? `+91${newValue.attributes.phone_number}`
                      : ""
                  );
                  setGender(
                    newValue.attributes.gender
                      ? newValue.attributes.gender.charAt(0).toUpperCase() +
                          newValue.attributes.gender.slice(1)
                      : ""
                  );
                  setDateOfBirth(
                    newValue.attributes.time_of_birth
                      ? new Date(newValue.attributes.time_of_birth)
                      : null
                  );
                  setPatientId(newValue.attributes.user_id);
                }
              }}
              onInputChange={(event, newInputValue) => {
                setSearchPatientsQuery(newInputValue);
              }}
              options={allPatients || []}
              noOptionsText="No patients found"
              getOptionLabel={(option) => {
                const name = option?.attributes?.name || "";
                const phone = option?.attributes?.phone_number || "";
                return `${name} (${phone})`;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Patients by Phone *"
                  variant="outlined"
                />
              )}
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <Box sx={{ flex: 1, backgroundColor: "#aaa", height: 1 }} />
            <Box px={2}>
              <Typography variant="body1">Or</Typography>
            </Box>
            <Box sx={{ flex: 1, backgroundColor: "#aaa", height: 1 }} />
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <ImageUploading
                acceptType={IMAGE_FILE_TYPES}
                maxFileSize={3000000}
                value={profileImage}
                onChange={(img) => {
                  setProfileImage(img);
                }}
              >
                {({ onImageUpload, dragProps, errors }) => (
                  <Box>
                    <Box className={classes.avatarUploadContainer}>
                      <Box
                        className={classes.avatarUploadInnerContainer}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        <Box>
                          <Tooltip placement="top" title="Add Photo" arrow>
                            <Avatar
                              className={classes.uploadAvatar}
                              src={profileImage && profileImage[0].dataURL}
                            />
                          </Tooltip>
                        </Box>

                        <Box className={classes.editIcon}>
                          <EditIcon color="primary" />
                        </Box>
                      </Box>

                      {errors && (
                        <Box className={classes.errorContainer}>
                          {errors.acceptType && (
                            <Typography className={classes.error}>
                              Please select image file
                            </Typography>
                          )}

                          {errors.maxFileSize && (
                            <Typography className={classes.error}>
                              Selected image file size exceed max file size
                              (3MB)
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </ImageUploading>
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextValidator
                    label="First Name *"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    validators={["required", "isBlank"]}
                    errorMessages={[
                      "First name is required",
                      "Please enter first name",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextValidator
                    label="Last Name *"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    validators={["required", "isBlank"]}
                    errorMessages={[
                      "Last name is required",
                      "Please enter last name",
                    ]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <PhoneInputValidator
                    autoFormat={false}
                    variant="outlined"
                    size="small"
                    label="Phone *"
                    fullWidth
                    defaultCountry="in"
                    countryCodeEditable={false}
                    value={phone}
                    onChange={(phone) => {
                      let phoneNumber = phone.replace(/[^0-9]+/g, "");
                      setPhone(
                        phoneNumber.startsWith("91")
                          ? `+${phoneNumber}`
                          : `+91${phoneNumber}`
                      );
                    }}
                    validators={["required", "isValidMobile"]}
                    errorMessages={[
                      "Phone is required",
                      "Please enter valid phone",
                    ]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <FormControl>
                    <RadioGroupValidator
                      row
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      validators={["required"]}
                      errorMessages={["Gender is required"]}
                    >
                      <Box className={classes.radioContainer}>
                        <Box className={classes.radioTextContainer}>
                          <Typography>Gender *</Typography>
                        </Box>
                        <Box>
                          <FormControlLabel
                            value="Male"
                            control={<Radio color="primary" />}
                            label="Male"
                          />
                          <FormControlLabel
                            value="Female"
                            control={<Radio color="primary" />}
                            label="Female"
                          />
                        </Box>
                      </Box>
                    </RadioGroupValidator>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePickerValidator
                      fullWidth
                      label="Date of Birth"
                      inputVariant="outlined"
                      size="small"
                      format="MM/dd/yyyy"
                      maxDate={new Date()}
                      value={dateOfBirth}
                      onChange={(date) => setDateOfBirth(date)}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions classes={{ root: classes.actionsContainer }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            disableElevation={true}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disableElevation={true}
          >
            Add
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
    patients: state.athletes.patients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addPatient: (data) => {
      return dispatch(addPatientRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    searchPatients: (data) => {
      return dispatch(searchPatientsRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPatient);
